/**
 * @prettier
 */

import { useTranslation } from "react-i18next";

import Header from "../../../components/Header";
import CustomButton from "../../../components/CustomButton";

import logo from "../../../assets/img/idpal_logo.svg";
import successImage from "../../../assets/animations/success_complete.svg";

import { ACTION_LABELS } from "../../../config/dataDogActionLabels";

import { imageAlt } from "../../../config/accessabilityRules";

function ShowRedirectURLState({
    showCustomClientsLogo,
    onContinueClick,
    onReturnToQrClick,
}) {
    const { t } = useTranslation();

    return (
        <div className="root-layout-container redirect-url-page">
            <Header showLanguageSelect isLogoHidden={showCustomClientsLogo} />
            <section className="content-wrapper">
                <div className="redirect-url-logo-container">
                    <object
                        type="image/svg+xml"
                        data={successImage}
                        height={"300px"}
                        width={"100%"}
                        aria-label={imageAlt.success}
                    />
                </div>
                <div className="redirect-url-content-wrapper">
                    <h1 className="redirect-url-text-container">
                        {t("idpal_mobile_handoff_completed_button")}
                    </h1>
                </div>

                <div className="redirect-url-cta-container">
                    <div className="redirect-url-cta-container-item">
                        <CustomButton
                            type="button"
                            label={t("idpal_continue")}
                            id="handoff-completed-cta-button"
                            className="outlined-button"
                            handleClick={onContinueClick}
                            actionDataLabel={
                                ACTION_LABELS.handoff.completedOnMobileButton
                            }
                        />
                    </div>
                    <div className="redirect-url-cta-container-item">
                        <CustomButton
                            type="button"
                            outlined
                            label={t("idpal_return_to_qr_code")}
                            id="return-to-qr-code-button"
                            handleClick={onReturnToQrClick}
                            actionDataLabel={
                                ACTION_LABELS.handoff.returnToQRCode
                            }
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ShowRedirectURLState;
